import type { DevicePorts } from "../../runtime/ports";
type KeyValueStore = DevicePorts["kv"];
import { captureException } from "@utils/captureException";

const PENDING_EMAIL_VERIFICATION_TOKEN_KEY = "pending_email_verification_token";
const PENDING_EMAIL_VERIFICATION_TOKEN_MAX_AGE_MS = 30 * 60 * 1000;

type PendingEmailVerificationToken = {
  createdAt: number;
  token: string;
};

export const setPendingEmailVerificationToken = (
  kv: KeyValueStore,
  token: string,
) => {
  kv.set(
    PENDING_EMAIL_VERIFICATION_TOKEN_KEY,
    JSON.stringify({ createdAt: Date.now(), token }),
  );
};

export const clearPendingEmailVerificationToken = (kv: KeyValueStore) => {
  kv.remove(PENDING_EMAIL_VERIFICATION_TOKEN_KEY);
};

export const getPendingEmailVerificationToken = (kv: KeyValueStore) => {
  const raw = kv.getString(PENDING_EMAIL_VERIFICATION_TOKEN_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as PendingEmailVerificationToken;
    if (
      typeof parsed.token !== "string" ||
      typeof parsed.createdAt !== "number" ||
      Date.now() - parsed.createdAt >
        PENDING_EMAIL_VERIFICATION_TOKEN_MAX_AGE_MS
    ) {
      clearPendingEmailVerificationToken(kv);
      return null;
    }

    return parsed.token;
  } catch (error) {
    clearPendingEmailVerificationToken(kv);
    captureException(error, {
      channel: "error",
      area: "auth",
      operation: "read-pending-email-verification-token",
    });
    return null;
  }
};
